import * as React from 'react';
import owaCalendarStrings from 'owa-strings/owa-calendar-strings';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { LocationPersonaControl, LocationPersonaControlViewState } from 'owa-location-persona';
import { LocationWellColor } from 'owa-location-common-well/lib/utils/generateLocationWellStyle';
import { observer } from 'mobx-react';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { RoomIcon } from 'owa-room-control';

let styles = require('./LocationSuggestionItem.scss');
let classNames = require('classnames/bind').bind(styles);

export interface LocationPickerItemProps {
    locationResult: LocationPersonaControlViewState;
    locationWellColor: LocationWellColor;
    roomFreeBusyEnabled: boolean;
}

/**
 * This the location picker suggestion, used to render an entry in the location search drop down
 */
@observer
export default class LocationSuggestionItem extends React.Component<LocationPickerItemProps, any> {
    render() {
        let { locationResult } = this.props;
        let hasAddress = !isNullOrWhiteSpace(locationResult.displayAddress);
        let isRoom = locationResult.personaType == 'Room';
        let isRoomWithAvailabilityInfo = isRoom && this.props.roomFreeBusyEnabled;

        let hasSecondLine = hasAddress || isRoomWithAvailabilityInfo;

        let iconImage = isRoom ? (
            <RoomIcon backgroundColor={this.props.locationWellColor.rootSecondaryColor} />
        ) : (
            <LocationPersonaControl locationPersona={locationResult} size={PersonaSize.size32} />
        );

        let secondaryLine = (
            <span className={classNames(styles.personaLineTwo, styles.personaTextLine)}>
                {locationResult.displayAddress}
            </span>
        );

        if (isRoomWithAvailabilityInfo) {
            let freebusyStyle = styles.availabilityUnknown;
            let freebusyText = owaCalendarStrings.unknownFreeBusy;

            if (locationResult.availability) {
                switch (locationResult.availability) {
                    case 'Free':
                        freebusyText = owaCalendarStrings.availableFreeBusy;
                        freebusyStyle = styles.availabilityFree;
                        break;
                    case 'Busy':
                        freebusyText = owaCalendarStrings.showAsBusy;
                        freebusyStyle = styles.availabilityBusy;
                        break;
                }
            }

            secondaryLine = (
                <div className={freebusyStyle}>
                    <Icon iconName={ControlIcons.Clock} className={styles.icon} />
                    <span className={classNames(styles.roomSecondaryText)}>{freebusyText}</span>
                </div>
            );
        }

        return (
            <div className={classNames(styles.container)} title={locationResult.displayName}>
                <div className={styles.personaImage}>{iconImage}</div>
                <div className={styles.personaText}>
                    <span
                        className={classNames(
                            styles.personaLineOne,
                            { singleLine: !hasSecondLine },
                            styles.personaTextLine
                        )}>
                        {locationResult.displayName}
                    </span>
                    {hasSecondLine && secondaryLine}
                </div>
            </div>
        );
    }
}
